import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../locale/jsonMessages';
import cs from '../../../../components/commonStyle.css';
import s from '../AdminDashboard.css';

const ChartSection = ({ title, subtitle, dates, children, containerClass, isRevenueChart, rangeType, timezoneLabel }) => (
    <div className={containerClass}>
        <div className={cx(cs.spaceBottom5, s.chartSectionHeaderFlex)}>
            <div>
                <h3 className={cx(cs.commonContentText, cs.fontWeightBold, cs.spaceBottom1)}>{title}</h3>
                <p className={cx(cs.commonSmallText, cs.greyText, isRevenueChart && s.revenueFeeSubtitle)}>{subtitle} {!isRevenueChart && <span>({dates})</span>}</p>
                {isRevenueChart && rangeType === 'hours' && (
                    <p className={cx(cs.commonSmallText, cs.greyText, cs.spaceTop1)}>
                        <FormattedMessage {...messages.timesInYourTimezone} values={{ offset: timezoneLabel || '—' }} />
                    </p>
                )}
            </div>
            {isRevenueChart &&
                <div className={s.revenueChartDotWrapper}>
                    <div className={cx(cs.commonSmallText, cs.greyText, s.chartDotText, 'chartDotTextRtl')}><FormattedMessage  {...messages.completeBookingAmount} /></div>
                    <div className={cx(cs.commonSmallText, cs.greyText, s.chartDotText, 'chartDotTextRtl')}><FormattedMessage  {...messages.adminRevenue} /></div>
                </div>}
        </div>
        <div>{children}</div>
    </div >
);

ChartSection.propTypes = {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};

export default withStyles(cs, s)(ChartSection);
